import type { VoidFunctionComponent } from 'react';

import Button from '../../generic/Button/Button';
import { BUTTON_TYPE } from '../../generic/Button/button-constants';
import AlphanumericCodeInput from '../../generic/Forms/AlphanumericCodeInput';
import VerificationCodeInput from '../../generic/Forms/VerificationCodeInput';
import { useAuthContext } from '../context/AuthContext';

/**
 * TOTP MFA verification form.
 * Displays code input with backup code toggle.
 */
const TotpMfaVerification: VoidFunctionComponent = () => {
  const { mfaCode, useBackupCode, toggleBackupCode, submitButton, status } = useAuthContext();
  return (
    <>
      <p className="text-center margin-bottom-md">
        {useBackupCode
          ? 'Enter one of your backup codes.'
          : 'Enter the 6-digit verification code from your authenticator app.'}
      </p>
      {useBackupCode ? (
        <AlphanumericCodeInput
          value={mfaCode.value}
          onChange={mfaCode.onChange}
          onComplete={submitButton.onSubmit}
          disabled={status.isLoading}
        />
      ) : (
        <VerificationCodeInput
          value={mfaCode.value}
          onChange={mfaCode.onChange}
          onComplete={submitButton.onSubmit}
          disabled={status.isLoading}
        />
      )}
      <div className="text-center margin-top-md">
        <Button
          type={BUTTON_TYPE.ANCHOR}
          onClick={toggleBackupCode}
          isDisabled={status.isLoading}
        >
          {useBackupCode ? 'Use authenticator app code' : 'Having trouble? Use a backup code'}
        </Button>
      </div>
    </>
  );
};

export default TotpMfaVerification;
